import { Text } from "@meditect/medibase-components";

export const SalesCannotDeleteNormalizedSaleError = () => {
  return (
    <Text>
      Cette vente est déclarée à la DGI : elle ne peut être annulée qu'avec remboursement, pour émettre la facture
      d'avoir.
    </Text>
  );
};
